(() => {
  const bar = document.getElementById('cro-mobile-purchase');
  if (!bar) return;
  const info = document.querySelector('[id^="ProductInfo-"]');
  if (!info) return;
  const action = bar.querySelector('button');
  const price = bar.querySelector('[data-price]');
  const mobile = matchMedia('(max-width: 749px)');
  const source = () => info.querySelector('product-form button[type="submit"]');
  let frame;
  function sync() {
    const button = source();
    if (!button) { bar.hidden = true; return; }
    const rect = button.getBoundingClientRect();
    const overlay = document.querySelector('cart-drawer.active, dialog[open], modal-dialog[open], details[open].menu-opening');
    const locked = document.body.classList.contains('overflow-hidden') || document.body.classList.contains('overflow-hidden-mobile');
    bar.hidden = !mobile.matches || rect.bottom >= 0 || !!overlay || locked;
    action.disabled = button.disabled || button.getAttribute('aria-disabled') === 'true';
    const label = button.querySelector('span:not(.hidden)');
    action.textContent = label?.textContent.trim() || button.textContent.trim();
    const current = info.querySelector('.price--on-sale .price-item--sale') || info.querySelector('.price__regular .price-item--regular');
    price.textContent = current?.textContent.trim() || '';
  }
  function schedule() { if (!frame) frame = requestAnimationFrame(() => { frame = null; sync(); }); }
  action.addEventListener('click', () => {
    const button = source();
    if (!button || button.disabled || button.getAttribute('aria-disabled') === 'true') return;
    button.click();
    schedule();
  });
  new MutationObserver(schedule).observe(info, {subtree:true,childList:true,attributes:true,characterData:true});
  new MutationObserver(schedule).observe(document.body, {attributes:true,attributeFilter:['class']});
  const drawer = document.querySelector('cart-drawer');
  if (drawer) new MutationObserver(schedule).observe(drawer, {attributes:true,attributeFilter:['class']});
  document.addEventListener('scroll', schedule, {passive:true,capture:true});
  window.addEventListener('resize', schedule, {passive:true});
  document.addEventListener('click', schedule);
  sync();
})();
